/**
 * @generated SignedSource<<eab41df62e1fb5613068d83be1dcce03>>
 * @relayHash 13258b2e2cfc92532f20e242537aa342
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 25aaf89a7ec6a739ccf31f351080c89552b25f262f7a84c4c2696e29656f1b73

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentBrowseConversationsQuery } from './VirtualAgentBrowseConversationsQuery.graphql';

import conversationFilterEnabled_provider from '@atlassian/jira-relay-provider/src/is-conversation-filter-enabled.relayprovider';
import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentBrowseConversationsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "25aaf89a7ec6a739ccf31f351080c89552b25f262f7a84c4c2696e29656f1b73",
    "metadata": {},
    "name": "VirtualAgentBrowseConversationsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": conversationFilterEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
